export const phone = (value) =>
  !!value && value?.length > 0 && value.indexOf("_") === -1
    ? undefined
    : "Invalid phone";
